import { ChangeDetectorRef, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BaseComponent } from '../base.component';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[myRouterLinkActive]',
    standalone: true
})
export class RouterLinkActiveDirective extends BaseComponent {
    @Input() set myRouterLinkActive(url: string | string[]) {
        this.checkIfUrlIsActive(url);
    }

    constructor(private router: Router,
                private element: ElementRef,
                private renderer: Renderer2,
                private cd: ChangeDetectorRef) {
        super();
    }

    private checkIfUrlIsActive(url: string | string[]) {
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            startWith(this.router),
            map((event: NavigationEnd) => event.url),
            takeUntil(this.destroyed$)
        ).subscribe((event: string) => {
            const eventUrl = event.substr(0, event.indexOf('?'));
            if ((url?.length > 0 && url.includes(eventUrl)) || eventUrl === url) {
                this.renderer.addClass(this.element.nativeElement, 'active');
                this.renderer.setAttribute(this.element.nativeElement, 'active', 'true');
            } else {
                this.renderer.removeClass(this.element.nativeElement, 'active');
                this.renderer.removeAttribute(this.element.nativeElement, 'active');
            }
            this.cd.detectChanges();
        });
    }
}
